<template>
    <!-- 新增表格数据的dialog -->
    <div>
        <el-dialog
            title="编辑轮播图"
            :visible.sync="editDialogVisible"
            :close-on-click-modal="false"
            width="40%"
            :before-close="handleToClose"
        >
            <el-form :model="editForm" ref="editForm" :rules="rules" label-width="120px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="轮播图名称" prop="bannerName">
                            <el-input v-model.trim="editForm.bannerName" placeholder="请输入专题名称" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="轮播图片" prop="bannerImg">
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :on-success="quaHandleAvatarSuccess"
                        :before-upload="quaBeforeAvatarUpload"
                        :on-change="uploadHandleChange"
                        :http-request="handleHttpRequest"
                        :auto-upload="false"
                    >
                        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div class="el-upload__tip" >建议上传一张宽高比为 2:1 的图片,建议:400px*200px</div>
                    </el-upload>
                </el-form-item>

                <div class="dialog-footer">
                    <el-button type="info" @click="handleToClose">取 消</el-button>
                    <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false">
            <div class="cropper-content">
                <div class="cropper" style="text-align: center;">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox"
                    ></vueCropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeScale(1)">+</el-button>
                <el-button @click="changeScale(-1)">-</el-button>
                <el-button @click="rotateLeft">↺</el-button>
                <el-button @click="rotateRight">↻</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="finish">上传</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ['editData'],
    data() {
        return {
            // 新增表单数据
            editForm: {
                bannerName: '', //专题名称
                id: '', //ID
                bannerImg: '' //Logo图片ID
            },
            // 验证规则
            rules: {
                bannerName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                bannerImg: [
                    {
                        required: true,
                        message: '请上传图片',
                        trigger: 'change'
                    }
                ]
            },
            uploadUrl: 'upload/fileupload', //图片上传地址
            imageUrl: '',
            editDialogVisible: false,
            option: {
                img: '', // 裁剪图片的地址
                info: false, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 600, // 默认生成截图框宽度
                autoCropHeight: 700, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: false, // 是否开启截图框宽高固定比例
                // fixedNumber: [5.8, 6], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                canMove: false,
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            dialogVisible: false, //图片裁剪的弹框dialog
            filename: '' //文件名
        };
    },
    created() {
        this.getMerchantInfo();
    },
    methods: {
        async getMerchantInfo(id) {
            this.editForm.id = id;
            const res = await this.$axios.post('banner/getData', {
                id: id
            });
            console.log(res);
            if (res.data.code == 0) {
                this.editForm = res.data.data;
                this.imageUrl = res.data.data.bannerUrl;
                this.editForm.color = 'rgba(19, 206, 102, 0.8)';
                this.editDialogVisible = true;
            }
        },
        submitForm(formName) {
            let that = this;
            console.log(that.editForm);
            that.$refs[formName].validate(valid => {
                if (valid) {
                    this.$axios
                        .post('banner/update', {
                            bannerName: that.editForm.bannerName,
                            bannerImg: that.editForm.bannerImg,
                            id: that.editForm.id
                        })
                        .then(res => {
                            console.log(res);
                            if (res.data.code == 0) {
                                that.$message.success('修改成功');
                                that.$parent.getSysInfoList();
                                that.editDialogVisible = false;
                            } else {
                                that.$message.error(res.data);
                            }
                            console.log(res);
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的修改吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$refs[formName].resetFields();
                    this.$emit('dialogEdit', false);
                })
                .catch(() => {});
        },
        resetFormData(formName) {
            this.$refs[formName].resetFields();
        },
        handleRemove(file, fileList) {},
        handleAvatarSuccess() {},
        beforeAvatarUploads(file) {},
        handleToClose() {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的修改吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$refs.editForm.resetFields();
                    this.imageUrl = '';
                    this.editDialogVisible = false;
                })
                .catch(() => {});
            // 重置表单
        },
        uploadHandleChange(file) {
            this.fileName = file.name;
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isIMG = ['.jpeg', '.jpg', '.png', '.bmp', '.gif', '.JPEG', '.JPG', '.GIF', '.PNG', '.BMP'].some(r =>
                file.name.endsWith(r)
            );
            if (!isIMG) {
                this.$message.error('上传图片只能是 jpg、jpeg、gif、 png、bmp 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            this.$nextTick(() => {
                this.option.img = URL.createObjectURL(file.raw);
                this.dialogVisible = true;
            });
        },
        handleToClose() {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的修改吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$refs.editForm.resetFields();
                this.editDialogVisible = false;
            });
        },
        //上传事件
        changeScale(val) {
            this.$refs.cropper.changeScale(val);
        },
        // 旋转图片
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        //确定裁剪
        finish() {
            this.$refs.cropper.getCropData(res => {
                let file = this.dataURLtoFile(res, this.fileName);
                this.handleHttpRequest(file);
                this.dialogVisible = false;
            });
        },
        // base64转file
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        //上传事件
        async handleHttpRequest(file) {
            let that = this;
            console.log(file);
            let formData = new FormData();
            formData.append('file', file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(that.uploadUrl, formData, config);
            console.log(res);
            if (res.data.code == 0) {
                that.editForm.bannerImg = res.data.data.id;
                that.imageUrl = res.data.data.url;
            } else {
                this.$message.error(res.data);
            }
        },
        //点击关闭按钮时关闭裁剪弹出框
        handleClose() {
            this.dialogVisible = false;
        },
        quaHandleAvatarSuccess(){},
        quaBeforeAvatarUpload(){}
    }
};
</script>

<style lang="less" scoped>
.dialog-footer {
    text-align: right;
}
/deep/.el-input-number .el-input__inner {
    text-align: left;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
.el-select {
    width: 100%;
}
.cropper-content .cropper {
    width: auto;
    height: 300px;
}
.avatar-uploader /deep/.el-upload{
    text-align: left!important;
}
</style>
